module.exports = __webpack_public_path__ + "static/media/Workshop_ARQUI._E_DESEN._EM_BLOCKCHAIN.b19a996e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/arquiDesenBlockchain/Workshop_ARQUI._E_DESEN._EM_BLOCKCHAIN.png
// module id = 60
// module chunks = 0